/**
 * Non-dismissable modal shown when the user's nbyula.com Discovery session
 * has expired.  The agent may still be running on the backend — we don't
 * force-navigate away, just ask the user to re-authenticate.
 */

import { useAuthStore } from "@/stores/authStore";

export function SessionExpiredModal() {
  const logout = useAuthStore((s) => s.logout);

  const handleReLogin = async () => {
    // Don't use window.location.href — full page reload crashes Qt 5.15
    // WebEngine. Calling logout() sets isAuthenticated=false in the auth
    // store, which makes App.tsx render LoginPage via React re-render.
    await logout();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-space/60 backdrop-blur-sm">
      <div className="bg-surface rounded-2xl shadow-xl max-w-sm w-full mx-4 p-6 text-center">
        {/* Lock icon */}
        <div className="w-12 h-12 rounded-xl bg-hydra-50 flex items-center justify-center mx-auto mb-4">
          <svg className="w-6 h-6 text-hydra" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
          </svg>
        </div>

        <h3 className="text-base font-bold text-space mb-1.5">Session Expired</h3>
        <p className="text-sm text-space-50 leading-relaxed mb-6">
          Your nbyula.com session has expired. Please sign in again to continue.
          Any running agent tasks will keep working in the background.
        </p>

        <button
          onClick={handleReLogin}
          className="w-full py-2.5 px-4 rounded-xl bg-primary text-on-primary text-sm font-semibold
                     hover:bg-jove-200 transition-colors"
        >
          Sign in again
        </button>
      </div>
    </div>
  );
}
